import { CACHE_FIRST, CACHE_FIRST_LONG, CACHE_INFINITY, CACHE_NETWORK_ONLY, CACHE_SWR } from '~sharedConfig'

import { ApiCacheTimeMode } from '../enums/apiCacheTimeMode'
import type { CacheConfig } from '../types/cacheConfig'

export const cacheConfigByMode: Record<ApiCacheTimeMode, CacheConfig> = {
	[ApiCacheTimeMode.StaleWhileRevalidate]: {
		staleTime: CACHE_SWR.stale,
		gcTime: CACHE_SWR.cache
	},
	[ApiCacheTimeMode.CacheFirst]: {
		staleTime: CACHE_FIRST.stale,
		gcTime: CACHE_FIRST.cache
	},
	[ApiCacheTimeMode.CacheFirstLong]: {
		staleTime: CACHE_FIRST_LONG.stale,
		gcTime: CACHE_FIRST_LONG.cache
	},
	[ApiCacheTimeMode.InfinityRequest]: {
		staleTime: CACHE_INFINITY.stale,
		gcTime: CACHE_INFINITY.cache
	},
	[ApiCacheTimeMode.NetworkOnly]: {
		staleTime: CACHE_NETWORK_ONLY.stale,
		gcTime: CACHE_NETWORK_ONLY.cache
	}
}
